import {dateTime} from "services/date";
import {AudienceSegment} from "types/AudienceSegment";

/**
 * Transform the given audience segment by deserializing object properties
 *
 * @internal
 * @param audienceSegment
 */
export default function deserializeAudienceSegment(audienceSegment: any): AudienceSegment {
    audienceSegment.created_at = dateTime(audienceSegment.created_at)
    audienceSegment.updated_at = dateTime(audienceSegment.updated_at)

    return audienceSegment;
}